import { useMutation, useQueryClient } from '@tanstack/react-query'
import { profile } from '@myap/ui-library'
import { putRequest } from '../utils/fetchOperations'
import { SCORE_SEND_KEY } from '../components/_common/reactquery'

const useSaveStudentScoreSendMutation = ({
  educationPeriodCd,
  diCode,
  org,
  optOut = false,
}) => {
  const queryClient = useQueryClient()
  const { apiUrl } = profile()
  return useMutation({
    mutationKey: [SCORE_SEND_KEY, educationPeriodCd],
    mutationFn: async ({ signal }) => {
      return await putRequest({
        url: `${apiUrl}/score-send-di/education-periods/${educationPeriodCd}`,
        payload: { diCode, optOut },
        signal,
      })
    },
    onSuccess: ({ diCode, userPromptType }, variables) => {
      queryClient.setQueryData([SCORE_SEND_KEY, educationPeriodCd], oldData => ({
        ...oldData,
        diCode,
        userPromptType,
        optOut,
        org,
      }))
    },
  })
}

export default useSaveStudentScoreSendMutation
